module.exports = __webpack_public_path__ + "static/media/unhappiest-new.10bb1563.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/unhappiest-new.svg
// module id = 937
// module chunks = 0